export enum EUserLevel {
  BASIC = 'BASIC',
  PRIME = 'PRIME',
  PERSAS = 'PERSAS',
  STAR = 'STAR',
  KING = 'KING',
}



export default EUserLevel;
